module.exports = __webpack_public_path__ + "img/paywithgoogle.af976ab1.png";